<template>
  <div class="transition content-info">
    <div class="icon-items">
      <BasicIcon
        name="danger"
        active
      />
    </div>

    <BasicText>
      {{ MSG_INFO_ESPACE_FORMATION_PDC }}<BasicLink
        :label="LABEL_LINK_ESPACE_FORMATION"
        @link-click="redirectExterne(URL_ESPACE_FORMATION)"
      />
    </BasicText>
  </div>
</template>

<script setup lang="ts">
  import type { CarteEvents } from '@/features/interface/machine-etats/types'
  import { BasicIcon, BasicLink, BasicText } from '@designSystem/components'
  import { LABEL_LINK_ESPACE_FORMATION, MSG_INFO_ESPACE_FORMATION_PDC, URL_ESPACE_FORMATION } from '../../shared'
  import { redirectExterne } from '@/features/shared/tools/url'

  const emits = defineEmits<CarteEvents<void>>()

  emits('outChanged', true)
</script>
<style lang="less" scoped>
  @import './ChoixCarte.less';

  .icon-items {
    background-color: white;
    color: @warning-500;
    align-self: center;
    margin-bottom: 10px;
    svg {
      fill: @warning-500;
      transform: scale(3);
    }
  }

  .content-info {
    width: 500px;
  }

  @media (max-width: 720px) {
    .content-info {
      width: 100%;
    }
  }
</style>
